module.exports = __webpack_public_path__ + "media/images/cv/gh_logo-740b697e7068d6ee27bcee8fb1cc2899.png";